import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class EmailChangeService {
  url: any = environment.API_URL;

  constructor(private http: HttpClient) { }

  sendOtp(email: string) {
    return this.http.post(this.url + 'user/send-email-otp', { newEmail:email });
  }

  verifyOtp(email: string, code: string) {
    return this.http.post<boolean>(this.url + 'user/verify-email-otp', { newEmail:email, otp:code });
  }
}
